// import React, { useContext, useState, useRef, useEffect } from "react";
// import {
//   Button,
//   Col,
//   DatePicker,
//   Form,
//   Row,
//   Card,
//   Collapse,
//   Panel,
//   Radio,
//   Input,
//   Checkbox,
// } from "antd";
// import { useHistory } from "react-router-dom";

// // import { GlobalStatesContext } from "../../common/providers";
// import BusesAutoSelect from "../../common/AutoCompleteSelect/BusesAutoSelect";
// import { useAuthContext } from "../../common/providers/AuthProvider";
// import moment from "moment";
// import queryString from "query-string";
// // import arrowImg from "../../assets/images/flight-arrow.png";
// import { SearchOutlined } from "@ant-design/icons";
// import "../buses-search/Buses.scss";

// const Buses = ({ modifySearch = false, busesSearchAPI }) => {
//   // const {
//   //   state: { busPersist },
//   // } = useContext(GlobalStatesContext);
//   const CheckboxGroup = Checkbox.Group;
//   const { Panel } = Collapse;
//   const city = useRef(null);
//   const searchBtn = useRef();
//   const [paramsTags, setParamsTags] = useState("");
//   let history = useHistory();
//   const tocityBox = useRef(null);
//   const fromDateBox = useRef(null);

//   const dateFormat = "DD-MM-YYYY";
//   const [form] = Form.useForm();

//   const { user } = useAuthContext();

//   const validateMessages = {
//     required: "",
//   };

//   //#region  Latest Code

//   const disabledOriginDate = (currentDate) => {
//     return currentDate < moment().startOf("day");
//   };

//   const [showDate, setShowDate] = useState(false);
//   const handleOnSubmit = (ref) => {
//     ref.current.focus();
//     if (ref === fromDateBox) {
//       setShowDate(true);
//     }
//   };

//   const [screen, setScreen] = useState(1)

//   const selectscreen = (e) =>  {
//     if (e.target) setScreen(e.target.value)
//   }

//   const submitForm = (values) => {
//     let source = queryString.parse(values.sourceId);
//     let destination = queryString.parse(values.destinationId);
//     let formData = {
//       sourceId: source.cityId,
//       destinationId: destination.cityId,
//       journeyDate: moment(values.journeyDate).format(),
//       sourceName: source.cityName,
//       destinationName: destination.cityName,
//       tags: values.filterOptions ? values.filterOptions.toString() : "",
//       Api: values.apisOptions ? values.apisOptions.toString() : ""
//     };
//     const query = queryString.stringify(formData);
//     {
//       console.log("checking submit",screen);
//     //  history.push("/admin/busresultsavailable?" + query);
//       history.push("/admin/busresults?" + query);
//     }
    
    


//     if (modifySearch) {
//       busesSearchAPI();
//     }

//   };
//   useEffect(() => {

//     if (modifySearch) {
//       let param = queryString.parse(document.location.search);

//       form.setFieldsValue({
//         sourceId: `cityName=${param.sourceName}&cityId=${param.sourceId}`,
//         destinationId: `cityName=${param.destinationName}&cityId=${param.destinationId}`,
//         journeyDate: moment(param.journeyDate),
//         filterOptions: param.tags.split(","),
//         apisOptions: param.Api.split(",")
//       });
//       setCarrier(param.tags.split(","));
//       setApisName(param.Api.split(","))
//     }
//   }, []);

//   // const handleSwap = () => {
//   //   const sourceId = form.getFieldValue("sourceId");
//   //   const destinationId = form.getFieldValue("destinationId");

//   //   if (sourceId && destinationId) {
//   //     form.setFieldsValue({
//   //       sourceId: destinationId,
//   //       destinationId: sourceId,
//   //     });
//   //     setDataFlip((prev) => !prev);
//   //   }
//   // };
//   const filterOptions = [
//     { name: "Seater", value: "Seater" },
//     { name: "Sleeper", value: "Sleeper" },
//     { name: "Ac", value: " Ac" },
//     { name: "NonAc", value: "NonAc" },

//     { name: "LiveTracking", value: "LiveTracking" },
//     { name: "MTicket", value: "MTicket" },
//     { name: "SingleLadies", value: "SingleLadies" },
//     { name: "Washroom ", value: "Washroom" },
//     { name: "Cancel ", value: "Cancel " },
//     { name: "Wifi ", value: "Wifi " },
//     { name: "Partial Cancel ", value: "PartialCancel " },
//     { name: "RTC ", value: "rtc " },
//     { name: "Refund ", value: "refund " },
//     { name: "Reschedule ", value: "reschedule " },
//     { name: "Safety ", value: "safety " },
//     { name: "Social Distance ", value: "socialDistance " },
//     { name: "Non RTC", value: "Non RTC" },
//     { name: "Morning", value: "morning" },
//     { name: "Afternoon", value: "afternoon" },
//     { name: "Evening", value: "evening" },
//     { name: "Night", value: "night" },
//   ];

//   const apisOptions = [
//     { name: "IRCT", value: "IRCT" },
//     { name: "REDB", value: "REDB" },
//     { name: "BTLA", value: "BTLA" },
//     { name: "EZIF", value: "EZIF" },
//     { name: "TRYR", value: "TRYR" },
//     { name: "ETST", value: "ETST" },
//     { name: "ITSG", value: "ITSG" },
//     { name: "VRLT", value: "VRLT" },
//     { name: "ZGBS", value: "ZGBS" },
//     { name: "YLBS", value: "YLBS" },
//   ]

//   const [carrier, setCarrier] = useState([]);
//   const handleFilterName = (e, name) => {
//     let array = [...carrier];
//     if (e.target.checked) {
//       array.push(name);
//     } else {
//       let index = array.indexOf(name);
//       if (index > -1) {
//         array.splice(index, 1);
//       }
//     }
//     setCarrier(array);
//   };

//   const [apisName, setApisName] = useState([]);
//   const handelApisName = (e, name) => {
//     let array = [...apisName];
//     if (e.target.checked) {
//       array.push(name);
//     } else {
//       let index = array.indexOf(name);
//       if (index > -1) {
//         array.splice(index, 1);
//       }
//     }
//     setApisName(array);
//   }

//   return (
//     <div>
//       <div className="hotels_search_box buses-panel-align-bd">
//         <div className="hotels-wrapper">
//           <Form
//             form={form}
//             className="hotel-search-form  bus-panel-bg"
//             name="busForm"
//             validateMessages={validateMessages}
//             onFinish={submitForm}
//             layout="vertical"
//             initialValues={{ filterOptions: "", apisOptions: "" }}
//           >
//             <Row className="bus-search-form" gutter={16}>
//               <Col md={8} xs={24} className="from-to-inputs bus-cols-info">
//                 <BusesAutoSelect
//                   formItemProps={{
//                     label: "Source",
//                     name: "sourceId",
//                     rules: [{ required: true }],
//                   }}
//                   selectProps={{
//                     size: "medium",
//                     placeholder: "Enter Source Name",
//                    }}
//                   api={"cdn/citiesMatched/"}
//                   refName={city}
//                   focusRef={tocityBox}
//                   handleOnSubmit={handleOnSubmit}
//                   modifySearch={modifySearch ? modifySearch : false}
//                 />
//               </Col>
//               <Col md={8} xs={24} className="from-to-inputs bus-cols-info">
//                 <BusesAutoSelect
//                   formItemProps={{
//                     label: "Destination",
//                     name: "destinationId",
//                     rules: [{ required: true }],
//                   }}
//                   selectProps={{
//                     size: "medium",
//                     placeholder: "Enter Destination Name",
//                    }}
//                   api={"cdn/citiesMatched/"}
//                   refName={tocityBox}
//                   focusRef={fromDateBox}
//                   handleOnSubmit={handleOnSubmit}
//                   modifySearch={modifySearch ? modifySearch : false}
//                 />
//               </Col>
//               <Col md={4} xs={24} className="from-to-inputs bus-cols-info">
//                 <Form.Item name="journeyDate" label="Journey Date" rules={[{ required: true }]}>
//                   <DatePicker
//                     allowClear={false}
//                     size="medium"
//                     className="search-inputs from-return-date"
//                     placeholder="Journey Date"
                    
//                     ref={fromDateBox}
//                     format={dateFormat}
//                     open={showDate}
//                     disabledDate={disabledOriginDate}
//                     onOpenChange={() => {
//                       setShowDate((prev) => !prev);
//                     }}
//                   />
//                 </Form.Item>
//               </Col>
//               {/* <Radio.Group onChange={selectscreen} value={screen} className="radio-button-margin">
//                 <Radio value={1}>OLD</Radio>
//                 <Radio value={2}>NEW</Radio>
//               </Radio.Group> */}

//               <Col md={4} xs={24} className="bus-cols-info">
//                 <Form.Item className="mr-none">
//                   <Button
//                     size="large"
//                     className="primary-btn train-search-btn bus-btn-pri"
//                     ref={searchBtn}
//                     htmlType="submit"
//                   >
//                     <SearchOutlined /> Search
//                   </Button>
//                 </Form.Item>
//               </Col>
//             </Row>






//             <Collapse className="collapse-margin"  >
//               <Panel header="More Options" key="1" >
//                 <Form.Item name="filterOptions" label="" className="check-margin">
//                   <CheckboxGroup className="css-for-row">
//                     <Row>
//                       {filterOptions.length > 0
//                         ? filterOptions.map((item) => {
//                           return (
//                             <Col
//                               key={item.value}
//                               // md={3}
//                               sm={8}
//                               xs={24}
//                               className="rows-of-more"
//                             >
//                               <Checkbox
//                                 className="checking"
//                                 value={item.value}
//                                 onChange={(e) =>
//                                   handleFilterName(e, item.name)
//                                 }
//                               >
//                                 {item.name}
//                               </Checkbox>
//                             </Col>
//                           );
//                         })
//                         : null}
//                     </Row>
//                   </CheckboxGroup>
//                 </Form.Item>


//                 {user?.role?.toUpperCase() == "ADMIN" && (
//                   <div className="label-panel-data">
//                     <Form.Item name="apisOptions" label=" " className="check-margin">
//                       <CheckboxGroup className="check-box-check">
//                         <Row>
//                           {apisOptions.length > 0
//                             ? apisOptions.map((item) => {
//                               return (
//                                 <Col
//                                   key={item.value}
//                                   //  md={3}
//                                   //  sm={8}
//                                   //  xs={24}
//                                   className="rows-of-more2"
//                                 >
//                                   <Checkbox
//                                     value={item.value}
//                                     onChange={(e) =>
//                                       handelApisName(e, item.name)
//                                     }
//                                   >
//                                     {item.name}
//                                   </Checkbox>
//                                 </Col>
//                               );
//                             })
//                             : null}
//                         </Row>
//                       </CheckboxGroup>
//                     </Form.Item>
//                   </div>
//                 )}
//               </Panel>

//             </Collapse>
//           </Form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Buses;






// import React, { useState, useRef, useEffect } from "react";
// import {
//   Button,
//   Col,
//   DatePicker,
//   Form,
//   Row,
//   Collapse,
//   Checkbox,
//   Tooltip,
//   message
// } from "antd";
// import { useHistory } from "react-router-dom";
// import { SearchOutlined, AudioOutlined, AudioMutedOutlined } from "@ant-design/icons";
// import BusApiClient from "../../helpers/BusApiClient";
// import BusesAutoSelect from "../../common/AutoCompleteSelect/BusesAutoSelect";
// import { useAuthContext } from "../../common/providers/AuthProvider";
// import moment from "moment";
// import queryString from "query-string";
// import "../buses-search/Buses.scss";

// const Buses = ({ modifySearch = false, busesSearchAPI }) => {
//   const CheckboxGroup = Checkbox.Group;
//   const { Panel } = Collapse;
//   const city = useRef(null);
//   const searchBtn = useRef();
//   const [paramsTags, setParamsTags] = useState("");
//   let history = useHistory();
//   const tocityBox = useRef(null);
//   const fromDateBox = useRef(null);

//   // Voice recognition states
//   const [isListening, setIsListening] = useState(false);
//   const [transcript, setTranscript] = useState("");
//   const recognitionRef = useRef(null);

//   // Cities data state
//   const [citiesData, setCitiesData] = useState([]);
//   const [isCitiesLoading, setIsCitiesLoading] = useState(false);

//   const dateFormat = "DD-MM-YYYY";
//   const [form] = Form.useForm();
//   const { user } = useAuthContext();

//   const validateMessages = {
//     required: "",
//   };

//   // Filter options and API options
//   const filterOptions = [
//     { name: "Seater", value: "Seater", keywords: ["seater", "sitting", "chair"] },
//     { name: "Sleeper", value: "Sleeper", keywords: ["sleeper", "sleep", "bed"] },
//     { name: "Ac", value: "Ac", keywords: ["ac", "air conditioned", "air conditioning"] },
//     { name: "NonAc", value: "NonAc", keywords: ["non ac", "non air conditioned"] },
//     { name: "LiveTracking", value: "LiveTracking", keywords: ["live tracking", "tracking", "gps"] },
//     { name: "MTicket", value: "MTicket", keywords: ["m ticket", "mobile ticket", "e ticket"] },
//     { name: "SingleLadies", value: "SingleLadies", keywords: ["single ladies", "ladies", "women"] },
//     { name: "Washroom", value: "Washroom", keywords: ["washroom", "toilet", "restroom"] },
//     { name: "Cancel", value: "Cancel", keywords: ["cancel", "cancellation"] },
//     { name: "Wifi", value: "Wifi", keywords: ["wifi", "internet"] },
//     { name: "Partial Cancel", value: "PartialCancel", keywords: ["partial cancel", "partial cancellation"] },
//     { name: "RTC", value: "rtc", keywords: ["rtc", "government"] },
//     { name: "Refund", value: "refund", keywords: ["refund", "refundable"] },
//     { name: "Reschedule", value: "reschedule", keywords: ["reschedule", "change date"] },
//     { name: "Safety", value: "safety", keywords: ["safety", "safe"] },
//     { name: "Social Distance", value: "socialDistance", keywords: ["social distance", "social distancing"] },
//     { name: "Non RTC", value: "Non RTC", keywords: ["non rtc", "private"] },
//     { name: "Morning", value: "morning", keywords: ["morning", "early"] },
//     { name: "Afternoon", value: "afternoon", keywords: ["afternoon", "midday"] },
//     { name: "Evening", value: "evening", keywords: ["evening", "dusk"] },
//     { name: "Night", value: "night", keywords: ["night", "late"] },
//   ];

//   const apisOptions = [
//     { name: "IRCT", value: "IRCT", keywords: ["irct", "irctc", "government"] },
//     { name: "REDB", value: "REDB", keywords: ["redbus", "red bus"] },
//     { name: "BTLA", value: "BTLA", keywords: ["btla"] },
//     { name: "EZIF", value: "EZIF", keywords: ["ezif"] },
//     { name: "TRYR", value: "TRYR", keywords: ["tryr"] },
//     { name: "ETST", value: "ETST", keywords: ["etst"] },
//     { name: "ITSG", value: "ITSG", keywords: ["itsg"] },
//     { name: "VRLT", value: "VRLT", keywords: ["vrl", "vrl travels"] },
//     { name: "ZGBS", value: "ZGBS", keywords: ["zgbs"] },
//     { name: "YLBS", value: "YLBS", keywords: ["ylbs"] },
//   ];

//   const [carrier, setCarrier] = useState([]);
//   const [apisName, setApisName] = useState([]);

//   useEffect(() => {
//     fetchCitiesData();
//   }, []);

//   useEffect(() => {
//     if (citiesData.length > 0) {
//       initializeVoiceRecognition();
//     }
//   }, [citiesData]);

//   const fetchCitiesData = async () => {
//     try {
//       setIsCitiesLoading(true);
//       const response = await BusApiClient.get(`cdn/cities`);
//       const cities = response.cities || [];
      
//       if (Array.isArray(cities)) {
//         setCitiesData(cities);
//       } else {
//         setCitiesData([]);
//       }
//     } catch (error) {
//       console.error('Error fetching cities data:', error);
//       message.error('Failed to load cities data for voice search');
//       setCitiesData([]);
//     } finally {
//       setIsCitiesLoading(false);
//     }
//   };

//   // Initialize voice recognition
//   const initializeVoiceRecognition = () => {
//     if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
//       const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//       recognitionRef.current = new SpeechRecognition();
//       recognitionRef.current.continuous = false;
//       recognitionRef.current.interimResults = false;
//       recognitionRef.current.lang = 'en-US';

//       recognitionRef.current.onresult = (event) => {
//         const transcript = event.results[0][0].transcript;
//         setTranscript(transcript);
//         processVoiceCommand(transcript);
//       };

//       recognitionRef.current.onerror = (event) => {
//         console.error('Speech recognition error', event.error);
//         message.error('Voice recognition error: ' + event.error);
//         setIsListening(false);
//       };

//       recognitionRef.current.onend = () => {
//         setIsListening(false);
//       };
//     } else {
//       console.warn('Speech recognition not supported in this browser');
//     }
//   };

//   // Process voice command and extract information
//   const processVoiceCommand = (text) => {
//     const lowerText = text.toLowerCase();
    
//     const cities = extractCities(lowerText);
//     const date = extractDate(lowerText);
//     const filters = extractFilterOptions(lowerText);
//     const apis = extractApiOptions(lowerText);

//     console.log('Voice command processed - Cities:', cities, 'Date:', date, 'Filters:', filters, 'APIs:', apis);
    
//     // Update form with extracted data
//     updateFormWithVoiceData(cities, date, filters, apis);
//   };

//   // Extract city names from voice text using cached cities data
//   const extractCities = (text) => {
//     console.log('Processing voice text:', text);
    
//     if (!citiesData || citiesData.length === 0) {
//       console.warn('No cities data available for voice search');
//       return [];
//     }
    
//     // Common patterns for travel phrases
//     const travelPatterns = [
//       /from\s+([^ ]+(?:\s+[^ ]+)*?)\s+to\s+([^ ]+(?:\s+[^ ]+)*?)/i,
//       /to\s+([^ ]+(?:\s+[^ ]+)*?)\s+from\s+([^ ]+(?:\s+[^ ]+)*?)/i,
//       /([^ ]+(?:\s+[^ ]+)*?)\s+to\s+([^ ]+(?:\s+[^ ]+)*?)/i,
//       /from\s+([^ ]+(?:\s+[^ ]+)*)/i,
//       /to\s+([^ ]+(?:\s+[^ ]+)*)/i
//     ];
    
//     const foundCities = [];
    
//     for (const pattern of travelPatterns) {
//       const match = text.match(pattern);
//       if (match) {
//         if (match[1] && match[2]) {
//           // Pattern like "from X to Y" or "X to Y"
//           foundCities.push(match[1].trim());
//           foundCities.push(match[2].trim());
//           break;
//         } else if (match[1]) {
//           // Pattern like "from X" or "to Y"
//           foundCities.push(match[1].trim());
//         }
//       }
//     }
    
//     // If no specific pattern found, try to find city names in the text
//     if (foundCities.length === 0) {
//       const cityKeywords = citiesData.map(city => {
//         const cityName = city.name || city.cityName || city.value || '';
//         return cityName.toLowerCase().trim();
//       }).filter(name => name !== '');

//       const sortedCities = cityKeywords.sort((a, b) => b.length - a.length);
//       let remainingText = text.toLowerCase();
      
//       sortedCities.forEach(cityName => {
//         const regex = new RegExp(`\\b${cityName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
//         if (regex.test(remainingText)) {
//           foundCities.push(cityName);
//           remainingText = remainingText.replace(regex, '');
//         }
//       });
//     }

//     return foundCities;
//   };

//   // Extract and parse date from voice text
//   const extractDate = (text) => {
//     const today = moment();
    
//     // Handle relative dates
//     if (text.includes('today')) {
//       return today;
//     } else if (text.includes('tomorrow')) {
//       return today.add(1, 'day');
//     } else if (text.includes('day after tomorrow')) {
//       return today.add(2, 'day');
//     } else if (text.includes('next week')) {
//       return today.add(7, 'day');
//     }
    
//     // Handle specific date patterns
//     const datePatterns = [
//       /(\d{1,2})(?:st|nd|rd|th)?\s+(january|february|march|april|may|june|july|august|september|october|november|december)/i,
//       /(january|february|march|april|may|june|july|august|september|october|november|december)\s+(\d{1,2})(?:st|nd|rd|th)?/i,
//       /(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?/,
//       /(\d{1,2})-(\d{1,2})(?:-(\d{2,4}))?/
//     ];
    
//     for (const pattern of datePatterns) {
//       const match = text.match(pattern);
//       if (match) {
//         let day, month, year;
        
//         if (pattern.source.includes('\\/') || pattern.source.includes('-')) {
//           // Handle DD/MM/YYYY or DD-MM-YYYY
//           day = parseInt(match[1]);
//           month = parseInt(match[2]) - 1;
//           year = match[3] ? parseInt(match[3]) : today.year();
//           if (year < 100) year += 2000;
//         } else {
//           // Handle month name patterns
//           const monthNames = {
//             'january': 0, 'february': 1, 'march': 2, 'april': 3, 'may': 4, 'june': 5,
//             'july': 6, 'august': 7, 'september': 8, 'october': 9, 'november': 10, 'december': 11
//           };
          
//           if (match[1] in monthNames) {
//             month = monthNames[match[1].toLowerCase()];
//             day = parseInt(match[2]);
//           } else {
//             month = monthNames[match[2].toLowerCase()];
//             day = parseInt(match[1]);
//           }
//           year = today.year();
//         }
        
//         const date = moment(new Date(year, month, day));
//         if (date.isValid() && !date.isBefore(today, 'day')) {
//           return date;
//         }
//       }
//     }
    
//     return null;
//   };

//   // Extract filter options from voice text
//   const extractFilterOptions = (text) => {
//     const foundFilters = [];
    
//     filterOptions.forEach(option => {
//       // Check if any of the keywords for this option are in the text
//       const hasKeyword = option.keywords.some(keyword => 
//         text.includes(keyword.toLowerCase())
//       );
      
//       if (hasKeyword) {
//         foundFilters.push(option.value);
//       }
//     });
    
//     return foundFilters;
//   };

//   // Extract API options from voice text
//   const extractApiOptions = (text) => {
//     const foundApis = [];
    
//     apisOptions.forEach(option => {
//       // Check if any of the keywords for this option are in the text
//       const hasKeyword = option.keywords.some(keyword => 
//         text.includes(keyword.toLowerCase())
//       );
      
//       if (hasKeyword) {
//         foundApis.push(option.value);
//       }
//     });
    
//     return foundApis;
//   };

//   // Update form with voice extracted data
//   const updateFormWithVoiceData = async (cities, date, filters, apis) => {
//     try {
//       let hasEnoughData = false;
//       let updates = [];
      
//       // Update cities if found
//       if (cities.length >= 2) {
//         const sourceCity = findCityInCache(cities[0]);
//         const destCity = findCityInCache(cities[1]);

//         if (sourceCity && destCity) {
//           form.setFieldsValue({
//             sourceId: sourceCity.name,
//             destinationId: destCity.name
//           });
//           hasEnoughData = true;
//           updates.push(`${sourceCity.name} to ${destCity.name}`);
//         }
//       } else if (cities.length === 1) {
//         const sourceCity = findCityInCache(cities[0]);
//         if (sourceCity) {
//           form.setFieldsValue({
//             sourceId: sourceCity.name
//           });
//           hasEnoughData = true;
//           updates.push(`From ${sourceCity.name}`);
//         }
//       }

//       // Update date if found
//       if (date) {
//         form.setFieldsValue({
//           journeyDate: date
//         });
//         hasEnoughData = hasEnoughData && true;
//         updates.push(`Date: ${date.format('DD-MM-YYYY')}`);
//       }

//       // Update filter options if found
//       if (filters.length > 0) {
//         form.setFieldsValue({
//           filterOptions: filters
//         });
//         setCarrier(filters);
//         updates.push(`Filters: ${filters.join(', ')}`);
//       }

//       // Update API options if found and user is admin
//       if (apis.length > 0 && user?.role?.toUpperCase() === "ADMIN") {
//         form.setFieldsValue({
//           apisOptions: apis
//         });
//         setApisName(apis);
//         updates.push(`APIs: ${apis.join(', ')}`);
//       }

//       // Show summary message
//       if (updates.length > 0) {
//         message.success(`Voice search applied: ${updates.join(' | ')}`);
//       }

//       if (hasEnoughData && cities.length >= 2 && date) {
//         message.success('Voice command processed! Searching buses...');
//         setTimeout(() => {
//           handleAutoSubmit();
//         }, 2000);
//       } else if (hasEnoughData) {
//         message.success('Voice command processed! Please check the form and click search.');
//       } else {
//         message.warning('Could not extract enough information from voice command. Please try again.');
//       }
//     } catch (error) {
//       console.error('Error processing voice command:', error);
//       message.error('Error processing voice command');
//     }
//   };

//   // Find city in cached cities data
//   const findCityInCache = (cityName) => {
//     try {
//       if (!citiesData || citiesData.length === 0) {
//         return null;
//       }

//       // Map common city names to standardized names
//       const cityNameMap = {
//         'vizag': 'visakhapatnam',
//         'cochin': 'kochi', 
//         'calicut': 'kozhikode',
//         'trivandrum': 'thiruvananthapuram',
//         'bombay': 'mumbai',
//         'calcutta': 'kolkata',
//         'madras': 'chennai',
//         'bangalore': 'bangalore',
//         'bengaluru': 'bengaluru',
//         'hyd': 'hyderabad',
//       };
      
//       const searchName = cityNameMap[cityName.toLowerCase()] || cityName;
//       const searchNameLower = searchName.toLowerCase().trim();

//       // First try exact name match
//       let foundCity = citiesData.find(city => {
//         const cityNameToCompare = (city.name || city.cityName || '').toLowerCase().trim();
//         return cityNameToCompare === searchNameLower;
//       });

//       // If exact match not found, try partial match but only for significant terms
//       if (!foundCity) {
//         foundCity = citiesData.find(city => {
//           const cityNameToCompare = (city.name || city.cityName || '').toLowerCase().trim();
        
//           // Only match if search term is at least 3 characters and it's a significant part of the city name
//           if (searchNameLower.length >= 3) {
//             // Check if city name starts with search term or search term is a complete word in city name
//             return cityNameToCompare.startsWith(searchNameLower) || 
//                    cityNameToCompare.includes(` ${searchNameLower} `) ||
//                    cityNameToCompare.endsWith(` ${searchNameLower}`);
//           }
//           return false;
//         });
//       }

//       // If still not found, try matching common major cities with fuzzy logic
//       if (!foundCity) {
//         foundCity = findMajorCityWithFuzzyMatch(searchNameLower);
//       }

//       if (foundCity) {
//         const cleanName = (foundCity.name || foundCity.cityName).replace(/\(.*?\)/g, "").trim();

//         return {
//           cityId: foundCity.code || foundCity.cityId,
//           name: cleanName
//         };
//       }
      
//       return null;
//     } catch (error) {
//       console.error('Error finding city in cache:', error);
//       return null;
//     }
//   };

//   // Helper function to find major cities with fuzzy matching
//   const findMajorCityWithFuzzyMatch = (searchName) => {
//     const majorCityVariations = {
//       'hyderabad': ['hyderabad', 'hyd', 'hyderbad', 'hyderabad'],
//       'bengaluru': ['bengaluru', 'bangalore', 'banglore', 'bengalore', 'banglor'],
//       'mumbai': ['mumbai', 'bombay'],
//       'kolkata': ['kolkata', 'calcutta'],
//       'chennai': ['chennai', 'madras'],
//       'pune': ['pune', 'puna'],
//       'ahmedabad': ['ahmedabad', 'amdavad'],
//       'jaipur': ['jaipur'],
//       'lucknow': ['lucknow'],
//       'kochi': ['kochi', 'cochin'],
//       'kozhikode': ['kozhikode', 'calicut'],
//       'thiruvananthapuram': ['thiruvananthapuram', 'trivandrum'],
//       'visakhapatnam': ['visakhapatnam', 'vizag', 'visakha'],
//       'vijayawada': ['vijayawada', 'vijayawara'],
//       'nagpur': ['nagpur'],
//       'indore': ['indore'],
//       'surat': ['surat'],
//       'patna': ['patna'],
//       'bhopal': ['bhopal'],
//       'ludhiana': ['ludhiana']
//     };

//     for (const [actualCity, variations] of Object.entries(majorCityVariations)) {
//       if (variations.some(variation => variation === searchName)) {
//         // Find this city in the cached data
//         const foundCity = citiesData.find(city => {
//           const cityName = (city.name || city.cityName || '').toLowerCase().trim();
//           return cityName === actualCity;
//         });
        
//         return foundCity || null;
//       }
//     }

//     return null;
//   };

//   // Auto-submit form after voice command
//   const handleAutoSubmit = () => {
//     form.validateFields()
//       .then(values => {
//         submitForm(values);
//       })
//       .catch(error => {
//         console.error('Form validation failed:', error);
//         message.error('Please fill all required fields');
//       });
//   };

//   // Toggle voice recognition
//   const toggleListening = () => {
//     if (!recognitionRef.current) {
//       message.error('Voice recognition not supported in your browser');
//       return;
//     }

//     if (isListening) {
//       recognitionRef.current.stop();
//       setIsListening(false);
//       message.info('Voice search stopped');
//     } else {
//       if (citiesData.length === 0) {
//         message.warning('Cities data still loading. Please wait...');
//         return;
//       }
      
//       setTranscript("");
//       recognitionRef.current.start();
//       setIsListening(true);
//       message.info('Listening... Speak your travel plans (e.g., "Hyderabad to Bangalore tomorrow with AC sleeper and wifi")');
//     }
//   };

//   // Existing form functions
//   const disabledOriginDate = (currentDate) => {
//     return currentDate < moment().startOf("day");
//   };

//   const [showDate, setShowDate] = useState(false);
//   const handleOnSubmit = (ref) => {
//     ref.current.focus();
//     if (ref === fromDateBox) {
//       setShowDate(true);
//     }
//   };

//   const submitForm = (values) => {
//     // Extract city information
//     let source, destination;
    
//     // Check if the value is in query string format or just city name
//     if (values.sourceId && values.sourceId.includes('cityName=')) {
//       source = queryString.parse(values.sourceId);
//     } else {
//       // If it's just a city name, find the city in cache
//       const sourceCity = findCityInCache(values.sourceId);
//       source = {
//         cityName: values.sourceId,
//         cityId: sourceCity ? sourceCity.cityId : values.sourceId
//       };
//     }
    
//     if (values.destinationId && values.destinationId.includes('cityName=')) {
//       destination = queryString.parse(values.destinationId);
//     } else {
//       // If it's just a city name, find the city in cache
//       const destCity = findCityInCache(values.destinationId);
//       destination = {
//         cityName: values.destinationId,
//         cityId: destCity ? destCity.cityId : values.destinationId
//       };
//     }
    
//     let formData = {
//       sourceId: source.cityId,
//       destinationId: destination.cityId,
//       journeyDate: moment(values.journeyDate).format(),
//       sourceName: source.cityName,
//       destinationName: destination.cityName,
//       tags: values.filterOptions ? values.filterOptions.toString() : "",
//       Api: values.apisOptions ? values.apisOptions.toString() : ""
//     };
//     const query = queryString.stringify(formData);
//     history.push("/admin/busresults?" + query);
    
//     if (modifySearch) {
//       busesSearchAPI();
//     }
//   };
  
//   useEffect(() => {
//     if (modifySearch) {
//       let param = queryString.parse(document.location.search);
//       form.setFieldsValue({
//         sourceId: `cityName=${param.sourceName}&cityId=${param.sourceId}`,
//         destinationId: `cityName=${param.destinationName}&cityId=${param.destinationId}`,
//         journeyDate: moment(param.journeyDate),
//         filterOptions: param.tags.split(","),
//         apisOptions: param.Api.split(",")
//       });
//       setCarrier(param.tags.split(","));
//       setApisName(param.Api.split(","))
//     }
//   }, []);

//   const handleFilterName = (e, name) => {
//     let array = [...carrier];
//     if (e.target.checked) {
//       array.push(name);
//     } else {
//       let index = array.indexOf(name);
//       if (index > -1) {
//         array.splice(index, 1);
//       }
//     }
//     setCarrier(array);
//   };

//   const handelApisName = (e, name) => {
//     let array = [...apisName];
//     if (e.target.checked) {
//       array.push(name);
//     } else {
//       let index = array.indexOf(name);
//       if (index > -1) {
//         array.splice(index, 1);
//       }
//     }
//     setApisName(array);
//   }

//   return (
//     <div>
//       <div className="hotels_search_box buses-panel-align-bd">
//         <div className="hotels-wrapper">
//           <Form
//             form={form}
//             className="hotel-search-form  bus-panel-bg"
//             name="busForm"
//             validateMessages={validateMessages}
//             onFinish={submitForm}
//             layout="vertical"
//             initialValues={{ filterOptions: [], apisOptions: [] }}
//           >
//             <Row className="bus-search-form" gutter={16}>
//               <Col md={6} xs={24} className="from-to-inputs bus-cols-info">
//                 <BusesAutoSelect
//                   formItemProps={{
//                     label: "Source",
//                     name: "sourceId",
//                     rules: [{ required: true }],
//                   }}
//                   selectProps={{
//                     size: "medium",
//                     placeholder: "Enter Source Name",
//                    }}
//                   api={"cdn/citiesMatched/"}
//                   refName={city}
//                   focusRef={tocityBox}
//                   handleOnSubmit={handleOnSubmit}
//                   modifySearch={modifySearch ? modifySearch : false}
//                 />
//               </Col>
//               <Col md={6} xs={24} className="from-to-inputs bus-cols-info">
//                 <BusesAutoSelect
//                   formItemProps={{
//                     label: "Destination",
//                     name: "destinationId",
//                     rules: [{ required: true }],
//                   }}
//                   selectProps={{
//                     size: "medium",
//                     placeholder: "Enter Destination Name",
//                    }}
//                   api={"cdn/citiesMatched/"}
//                   refName={tocityBox}
//                   focusRef={fromDateBox}
//                   handleOnSubmit={handleOnSubmit}
//                   modifySearch={modifySearch ? modifySearch : false}
//                 />
//               </Col>
//               <Col md={4} xs={24} className="from-to-inputs bus-cols-info">
//                 <Form.Item name="journeyDate" label="Journey Date" rules={[{ required: true }]}>
//                   <DatePicker
//                     allowClear={false}
//                     size="medium"
//                     className="search-inputs from-return-date"
//                     placeholder="Journey Date"
//                     ref={fromDateBox}
//                     format={dateFormat}
//                     open={showDate}
//                     disabledDate={disabledOriginDate}
//                     onOpenChange={() => {
//                       setShowDate((prev) => !prev);
//                     }}
//                   />
//                 </Form.Item>
//               </Col>

//               <Col md={4} xs={24} className="bus-cols-info">
//                 <Form.Item className="mr-none">
//                   <Button
//                     size="large"
//                     className="primary-btn train-search-btn bus-btn-pri"
//                     ref={searchBtn}
//                     htmlType="submit"
//                   >
//                     <SearchOutlined /> Search
//                   </Button>
//                 </Form.Item>
//               </Col>

//               {/* Voice Recognition Button */}
//               <Col md={2} xs={24} className="bus-cols-info">
//                 <Form.Item label=" ">
//                   <Tooltip title={isListening ? "Stop listening" : `Voice search ${isCitiesLoading ? '(Loading cities...)' : '(Ready)'}`}>
//                     <Button
//                       size="large"
//                       className={`voice-btn ${isListening ? 'listening' : ''} ${isCitiesLoading ? 'loading' : ''}`}
//                       onClick={toggleListening}
//                       disabled={isCitiesLoading}
//                       style={{
//                         height: '40px',
//                         width: '40px',
//                         borderRadius: '50%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         backgroundColor: isListening ? '#ff4d4f' : (isCitiesLoading ? '#d9d9d9' : '#1890ff'),
//                         border: 'none'
//                       }}
//                     >
//                       {isListening ? 
//                         <AudioMutedOutlined style={{ color: 'white', fontSize: '18px' }} /> : 
//                         <AudioOutlined style={{ color: 'white', fontSize: '18px' }} />
//                       }
//                     </Button>
//                   </Tooltip>
//                 </Form.Item>
//               </Col>
//             </Row>

//             <Collapse className="collapse-margin">
//               <Panel header="More Options" key="1">
//                 <Form.Item name="filterOptions" label="" className="check-margin">
//                   <CheckboxGroup className="css-for-row">
//                     <Row>
//                       {filterOptions.map((item) => (
//                         <Col key={item.value} sm={8} xs={24} className="rows-of-more">
//                           <Checkbox
//                             className="checking"
//                             value={item.value}
//                             onChange={(e) => handleFilterName(e, item.name)}
//                           >
//                             {item.name}
//                           </Checkbox>
//                         </Col>
//                       ))}
//                     </Row>
//                   </CheckboxGroup>
//                 </Form.Item>

//                 {user?.role?.toUpperCase() == "ADMIN" && (
//                   <div className="label-panel-data">
//                     <Form.Item name="apisOptions" label=" " className="check-margin">
//                       <CheckboxGroup className="check-box-check">
//                         <Row>
//                           {apisOptions.map((item) => (
//                             <Col key={item.value} className="rows-of-more2">
//                               <Checkbox
//                                 value={item.value}
//                                 onChange={(e) => handelApisName(e, item.name)}
//                               >
//                                 {item.name}
//                               </Checkbox>
//                             </Col>
//                           ))}
//                         </Row>
//                       </CheckboxGroup>
//                     </Form.Item>
//                   </div>
//                 )}
//               </Panel>
//             </Collapse>
//           </Form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Buses;
import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Row,
  Collapse,
  Checkbox,
  Tooltip,
  message,
  Tag,
  Alert,
  Space
} from "antd";
import { useHistory } from "react-router-dom";
import { SearchOutlined, AudioOutlined, AudioMutedOutlined, CheckCircleOutlined } from "@ant-design/icons";
import BusApiClient from "../../helpers/BusApiClient";
import BusesAutoSelect from "../../common/AutoCompleteSelect/BusesAutoSelect";
import { useAuthContext } from "../../common/providers/AuthProvider";
import moment from "moment";
import queryString from "query-string";
// import { SearchOutlined } from "@ant-design/icons";
import "../buses-search/Buses.scss";

const Buses = ({ modifySearch = false, busesSearchAPI }) => {
  const CheckboxGroup = Checkbox.Group;
  const { Panel } = Collapse;
  const city = useRef(null);
  const searchBtn = useRef();
  const [paramsTags, setParamsTags] = useState("");
  let history = useHistory();
  const tocityBox = useRef(null);
  const fromDateBox = useRef(null);

  // Voice recognition states
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [voiceDetectedTags, setVoiceDetectedTags] = useState([]);
  const [voiceDetectedApis, setVoiceDetectedApis] = useState([]);
  const [showVoiceFeedback, setShowVoiceFeedback] = useState(false);
  const recognitionRef = useRef(null);

  // Cities data state
  const [citiesData, setCitiesData] = useState([]);
  const [isCitiesLoading, setIsCitiesLoading] = useState(false);

  const dateFormat = "DD-MM-YYYY";
  const [form] = Form.useForm();
  const { user } = useAuthContext();

  const validateMessages = {
    required: "",
  };

  // Enhanced filter options with more specific keywords
  const filterOptions = [
    { name: "Seater", value: "Seater", keywords: ["seater", "sitting", "chair", "seat"] },
    { name: "Sleeper", value: "Sleeper", keywords: ["sleeper", "sleep", "bed", "berth"] },
    { name: "Ac", value: "Ac", keywords: ["ac", "air conditioned", "air conditioning", "cooling", "a/c"] },
    { name: "NonAc", value: "NonAc", keywords: ["non ac", "non air conditioned", "non air conditioning", "without ac", "non-a/c"] },
    { name: "LiveTracking", value: "LiveTracking", keywords: ["live tracking", "tracking", "gps", "live location", "real time tracking"] },
    { name: "MTicket", value: "MTicket", keywords: ["m ticket", "mobile ticket", "e ticket", "digital ticket", "electronic ticket"] },
    { name: "SingleLadies", value: "SingleLadies", keywords: ["single ladies", "ladies", "women", "female", "women only"] },
    { name: "Washroom", value: "Washroom", keywords: ["washroom", "toilet", "restroom", "bathroom", "lavatory"] },
    { name: "Cancel", value: "Cancel", keywords: ["cancel", "cancellation", "cancelable", "cancelled"] },
    { name: "Wifi", value: "Wifi", keywords: ["wifi", "internet", "wireless", "wi-fi"] },
    { name: "Partial Cancel", value: "PartialCancel", keywords: ["partial cancel", "partial cancellation", "partially cancel"] },
    { name: "RTC", value: "rtc", keywords: ["rtc", "government", "state transport", "government bus"] },
    { name: "Refund", value: "refund", keywords: ["refund", "refundable", "money back", "refunded"] },
    { name: "Reschedule", value: "reschedule", keywords: ["reschedule", "change date", "postpone", "rescheduled"] },
    { name: "Safety", value: "safety", keywords: ["safety", "safe", "secure", "security"] },
    { name: "Social Distance", value: "socialDistance", keywords: ["social distance", "social distancing", "distancing", "covid safe"] },
    { name: "Non RTC", value: "Non RTC", keywords: ["non rtc", "private", "private bus", "non government"] },
    { name: "Morning", value: "morning", keywords: ["morning", "early", "sunrise", "6am", "7am", "8am", "9am"] },
    { name: "Afternoon", value: "afternoon", keywords: ["afternoon", "midday", "noon", "12pm", "1pm", "2pm", "3pm"] },
    { name: "Evening", value: "evening", keywords: ["evening", "dusk", "sunset", "4pm", "5pm", "6pm", "7pm"] },
    { name: "Night", value: "night", keywords: ["night", "late", "overnight", "8pm", "9pm", "10pm", "11pm"] },
  ];

  const apisOptions = [
    { name: "IRCT", value: "IRCT", keywords: ["irct", "irctc", "government", "railways"] },
    { name: "REDB", value: "REDB", keywords: ["redbus", "red bus", "redbus.com"] },
    { name: "BTLA", value: "BTLA", keywords: ["btla"] },
    { name: "EZIF", value: "EZIF", keywords: ["ezif"] },
    { name: "TRYR", value: "TRYR", keywords: ["tryr"] },
    { name: "ETST", value: "ETST", keywords: ["etst"] },
    { name: "ITSG", value: "ITSG", keywords: ["itsg"] },
    { name: "VRLT", value: "VRLT", keywords: ["vrl", "vrl travels"] },
    { name: "ZGBS", value: "ZGBS", keywords: ["zgbs"] },
    { name: "YLBS", value: "YLBS", keywords: ["ylbs"] },
  ];

  const [carrier, setCarrier] = useState([]);
  const [apisName, setApisName] = useState([]);

  useEffect(() => {
    fetchCitiesData();
  }, []);

  useEffect(() => {
    if (citiesData.length > 0) {
      initializeVoiceRecognition();
    }
  }, [citiesData]);

  const fetchCitiesData = async () => {
    try {
      setIsCitiesLoading(true);
      const response = await BusApiClient.get(`cdn/cities`);
      const cities = response.cities || [];
      
      if (Array.isArray(cities)) {
        setCitiesData(cities);
      } else {
        setCitiesData([]);
      }
    } catch (error) {
      console.error('Error fetching cities data:', error);
      message.error('Failed to load cities data for voice search');
      setCitiesData([]);
    } finally {
      setIsCitiesLoading(false);
    }
  };

  // Initialize voice recognition
  const initializeVoiceRecognition = () => {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = false;
      recognitionRef.current.interimResults = false;
      recognitionRef.current.lang = 'en-US';

      recognitionRef.current.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setTranscript(transcript);
        processVoiceCommand(transcript);
      };

      recognitionRef.current.onerror = (event) => {
        console.error('Speech recognition error', event.error);
        message.error('Voice recognition error: ' + event.error);
        setIsListening(false);
        setShowVoiceFeedback(false);
      };

      recognitionRef.current.onend = () => {
        setIsListening(false);
      };
    } else {
      console.warn('Speech recognition not supported in this browser');
    }
  };

  // Process voice command and extract information
  const processVoiceCommand = (text) => {
    const lowerText = text.toLowerCase();
    
    const cities = extractCities(lowerText);
    const date = extractDate(lowerText);
    const filters = extractFilterOptions(lowerText);
    const apis = extractApiOptions(lowerText);

    console.log('Voice command processed - Cities:', cities, 'Date:', date, 'Filters:', filters, 'APIs:', apis);
    
    // Update form with extracted data
    updateFormWithVoiceData(cities, date, filters, apis);
  };

  // Extract city names from voice text using cached cities data
  const extractCities = (text) => {
    if (!citiesData || citiesData.length === 0) {
      return [];
    }
    
    const travelPatterns = [
      /from\s+([^ ]+(?:\s+[^ ]+)*?)\s+to\s+([^ ]+(?:\s+[^ ]+)*?)/i,
      /to\s+([^ ]+(?:\s+[^ ]+)*?)\s+from\s+([^ ]+(?:\s+[^ ]+)*?)/i,
      /([^ ]+(?:\s+[^ ]+)*?)\s+to\s+([^ ]+(?:\s+[^ ]+)*?)/i,
      /from\s+([^ ]+(?:\s+[^ ]+)*)/i,
      /to\s+([^ ]+(?:\s+[^ ]+)*)/i
    ];
    
    const foundCities = [];
    
    for (const pattern of travelPatterns) {
      const match = text.match(pattern);
      if (match) {
        if (match[1] && match[2]) {
          foundCities.push(match[1].trim());
          foundCities.push(match[2].trim());
          break;
        } else if (match[1]) {
          foundCities.push(match[1].trim());
        }
      }
    }
    
    if (foundCities.length === 0) {
      const cityKeywords = citiesData.map(city => {
        const cityName = city.name || city.cityName || city.value || '';
        return cityName.toLowerCase().trim();
      }).filter(name => name !== '');

      const sortedCities = cityKeywords.sort((a, b) => b.length - a.length);
      let remainingText = text.toLowerCase();
      
      sortedCities.forEach(cityName => {
        const regex = new RegExp(`\\b${cityName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        if (regex.test(remainingText)) {
          foundCities.push(cityName);
          remainingText = remainingText.replace(regex, '');
        }
      });
    }

    return foundCities;
  };

  // Extract and parse date from voice text
  const extractDate = (text) => {
    const today = moment();
    
    if (text.includes('today')) {
      return today;
    } else if (text.includes('tomorrow')) {
      return today.add(1, 'day');
    } else if (text.includes('day after tomorrow')) {
      return today.add(2, 'day');
    } else if (text.includes('next week')) {
      return today.add(7, 'day');
    }
    
    const datePatterns = [
      /(\d{1,2})(?:st|nd|rd|th)?\s+(january|february|march|april|may|june|july|august|september|october|november|december)/i,
      /(january|february|march|april|may|june|july|august|september|october|november|december)\s+(\d{1,2})(?:st|nd|rd|th)?/i,
      /(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?/,
      /(\d{1,2})-(\d{1,2})(?:-(\d{2,4}))?/
    ];
    
    for (const pattern of datePatterns) {
      const match = text.match(pattern);
      if (match) {
        let day, month, year;
        
        if (pattern.source.includes('\\/') || pattern.source.includes('-')) {
          day = parseInt(match[1]);
          month = parseInt(match[2]) - 1;
          year = match[3] ? parseInt(match[3]) : today.year();
          if (year < 100) year += 2000;
        } else {
          const monthNames = {
            'january': 0, 'february': 1, 'march': 2, 'april': 3, 'may': 4, 'june': 5,
            'july': 6, 'august': 7, 'september': 8, 'october': 9, 'november': 10, 'december': 11
          };
          
          if (match[1] in monthNames) {
            month = monthNames[match[1].toLowerCase()];
            day = parseInt(match[2]);
          } else {
            month = monthNames[match[2].toLowerCase()];
            day = parseInt(match[1]);
          }
          year = today.year();
        }
        
        const date = moment(new Date(year, month, day));
        if (date.isValid() && !date.isBefore(today, 'day')) {
          return date;
        }
      }
    }
    
    return null;
  };

  // IMPROVED: Extract filter options from voice text with better matching
  const extractFilterOptions = (text) => {
    const foundFilters = [];
    
    filterOptions.forEach(option => {
      let matched = false;
      
      // Check each keyword with word boundaries for exact matching
      for (const keyword of option.keywords) {
        // Create regex with word boundaries to avoid partial matches
        const regex = new RegExp(`\\b${keyword}\\b`, 'i');
        if (regex.test(text)) {
          matched = true;
          break;
        }
      }
      
      if (matched) {
        foundFilters.push(option.value);
      }
    });
    
    return foundFilters;
  };

  // IMPROVED: Extract API options from voice text with better matching
  const extractApiOptions = (text) => {
    const foundApis = [];
    
    apisOptions.forEach(option => {
      let matched = false;
      
      // Check each keyword with word boundaries for exact matching
      for (const keyword of option.keywords) {
        const regex = new RegExp(`\\b${keyword}\\b`, 'i');
        if (regex.test(text)) {
          matched = true;
          break;
        }
      }
      
      if (matched) {
        foundApis.push(option.value);
      }
    });
    
    return foundApis;
  };

  // Update form with voice extracted data
  const updateFormWithVoiceData = async (cities, date, filters, apis) => {
    try {
      let hasEnoughData = false;
      let updates = [];
      
      // Show voice feedback
      setShowVoiceFeedback(true);
      setVoiceDetectedTags(filters);
      setVoiceDetectedApis(apis);

      // Update cities if found
      if (cities.length >= 2) {
        const sourceCity = findCityInCache(cities[0]);
        const destCity = findCityInCache(cities[1]);

        if (sourceCity && destCity) {
          form.setFieldsValue({
            sourceId: sourceCity.name,
            destinationId: destCity.name
          });
          hasEnoughData = true;
          updates.push(`${sourceCity.name} to ${destCity.name}`);
        }
      } else if (cities.length === 1) {
        const sourceCity = findCityInCache(cities[0]);
        if (sourceCity) {
          form.setFieldsValue({
            sourceId: sourceCity.name
          });
          hasEnoughData = true;
          updates.push(`From ${sourceCity.name}`);
        }
      }

      // Update date if found
      if (date) {
        form.setFieldsValue({
          journeyDate: date
        });
        hasEnoughData = hasEnoughData && true;
        updates.push(`Date: ${date.format('DD-MM-YYYY')}`);
      }

      // Update filter options if found - ONLY set the detected ones
      if (filters.length > 0) {
        // Get current filter values to preserve manually selected ones if not conflicting
        const currentFilters = form.getFieldValue('filterOptions') || [];
        
        // Combine current filters with voice detected ones, avoiding duplicates
        const combinedFilters = [...new Set([...currentFilters, ...filters])];
        
        form.setFieldsValue({
          filterOptions: combinedFilters
        });
        setCarrier(combinedFilters);
        updates.push(`Filters: ${filters.map(f => getFilterDisplayName(f)).join(', ')}`);
      }

      // Update API options if found and user is admin
      if (apis.length > 0 && user?.role?.toUpperCase() === "ADMIN") {
        // Get current API values to preserve manually selected ones if not conflicting
        const currentApis = form.getFieldValue('apisOptions') || [];
        
        // Combine current APIs with voice detected ones, avoiding duplicates
        const combinedApis = [...new Set([...currentApis, ...apis])];
        
        form.setFieldsValue({
          apisOptions: combinedApis
        });
        setApisName(combinedApis);
        updates.push(`APIs: ${apis.map(a => getApiDisplayName(a)).join(', ')}`);
      }

      // Show summary message with visual feedback
      if (updates.length > 0) {
        message.success({
          content: (
            <div>
              <div>🎤 Voice search applied:</div>
              <div style={{ marginTop: '8px' }}>
                {updates.map((update, index) => (
                  <div key={index}>✓ {update}</div>
                ))}
              </div>
            </div>
          ),
          duration: 4,
        });
      }

      // Auto-hide voice feedback after 5 seconds
      setTimeout(() => {
        setShowVoiceFeedback(false);
      }, 5000);

      if (hasEnoughData && cities.length >= 2 && date) {
        setTimeout(() => {
          message.success('Searching buses...');
          handleAutoSubmit();
        }, 2000);
      } else if (hasEnoughData) {
        message.info('Voice command processed! Please check the form and click search.');
      } else {
        message.warning('Could not extract enough information from voice command. Please try again.');
        setShowVoiceFeedback(false);
      }
    } catch (error) {
      console.error('Error processing voice command:', error);
      message.error('Error processing voice command');
      setShowVoiceFeedback(false);
    }
  };

  // Find city in cached cities data
  const findCityInCache = (cityName) => {
    try {
      if (!citiesData || citiesData.length === 0) {
        return null;
      }

      const cityNameMap = {
        'vizag': 'visakhapatnam',
        'cochin': 'kochi', 
        'calicut': 'kozhikode',
        'trivandrum': 'thiruvananthapuram',
        'bombay': 'mumbai',
        'calcutta': 'kolkata',
        'madras': 'chennai',
        'bangalore': 'bangalore',
        'bengaluru': 'bengaluru',
        'hyd': 'hyderabad',
      };
      
      const searchName = cityNameMap[cityName.toLowerCase()] || cityName;
      const searchNameLower = searchName.toLowerCase().trim();

      let foundCity = citiesData.find(city => {
        const cityNameToCompare = (city.name || city.cityName || '').toLowerCase().trim();
        return cityNameToCompare === searchNameLower;
      });

      if (!foundCity) {
        foundCity = citiesData.find(city => {
          const cityNameToCompare = (city.name || city.cityName || '').toLowerCase().trim();
          if (searchNameLower.length >= 3) {
            return cityNameToCompare.startsWith(searchNameLower) || 
                   cityNameToCompare.includes(` ${searchNameLower} `) ||
                   cityNameToCompare.endsWith(` ${searchNameLower}`);
          }
          return false;
        });
      }

      if (!foundCity) {
        foundCity = findMajorCityWithFuzzyMatch(searchNameLower);
      }

      if (foundCity) {
        const cleanName = (foundCity.name || foundCity.cityName).replace(/\(.*?\)/g, "").trim();
        return {
          cityId: foundCity.code || foundCity.cityId,
          name: cleanName
        };
      }
      
      return null;
    } catch (error) {
      console.error('Error finding city in cache:', error);
      return null;
    }
  };

  // Helper function to find major cities with fuzzy matching
  const findMajorCityWithFuzzyMatch = (searchName) => {
    const majorCityVariations = {
      'hyderabad': ['hyderabad', 'hyd', 'hyderbad', 'hyderabad'],
      'bengaluru': ['bengaluru', 'bangalore', 'banglore', 'bengalore', 'banglor'],
      'mumbai': ['mumbai', 'bombay'],
      'kolkata': ['kolkata', 'calcutta'],
      'chennai': ['chennai', 'madras'],
      'pune': ['pune', 'puna'],
      'ahmedabad': ['ahmedabad', 'amdavad'],
      'jaipur': ['jaipur'],
      'lucknow': ['lucknow'],
      'kochi': ['kochi', 'cochin'],
      'kozhikode': ['kozhikode', 'calicut'],
      'thiruvananthapuram': ['thiruvananthapuram', 'trivandrum'],
      'visakhapatnam': ['visakhapatnam', 'vizag', 'visakha'],
      'vijayawada': ['vijayawada', 'vijayawara'],
      'nagpur': ['nagpur'],
      'indore': ['indore'],
      'surat': ['surat'],
      'patna': ['patna'],
      'bhopal': ['bhopal'],
      'ludhiana': ['ludhiana']
    };

    for (const [actualCity, variations] of Object.entries(majorCityVariations)) {
      if (variations.some(variation => variation === searchName)) {
        const foundCity = citiesData.find(city => {
          const cityName = (city.name || city.cityName || '').toLowerCase().trim();
          return cityName === actualCity;
        });
        return foundCity || null;
      }
    }

    return null;
  };

  // Auto-submit form after voice command
  const handleAutoSubmit = () => {
    form.validateFields()
      .then(values => {
        submitForm(values);
      })
      .catch(error => {
        console.error('Form validation failed:', error);
        message.error('Please fill all required fields');
      });
  };

  // Toggle voice recognition
  const toggleListening = () => {
    if (!recognitionRef.current) {
      message.error('Voice recognition not supported in your browser');
      return;
    }

    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
      setShowVoiceFeedback(false);
      message.info('Voice search stopped');
    } else {
      if (citiesData.length === 0) {
        message.warning('Cities data still loading. Please wait...');
        return;
      }
      
      setTranscript("");
      setVoiceDetectedTags([]);
      setVoiceDetectedApis([]);
      recognitionRef.current.start();
      setIsListening(true);
      message.info('Listening... Speak your travel plans (e.g., "Hyderabad to Bangalore tomorrow with AC sleeper and wifi")');
    }
  };

  // Get display name for filter value
  const getFilterDisplayName = (value) => {
    const filter = filterOptions.find(opt => opt.value === value);
    return filter ? filter.name : value;
  };

  // Get display name for API value
  const getApiDisplayName = (value) => {
    const api = apisOptions.find(opt => opt.value === value);
    return api ? api.name : value;
  };

  // Existing form functions
  const disabledOriginDate = (currentDate) => {
    return currentDate < moment().startOf("day");
  };

  const [showDate, setShowDate] = useState(false);
  const handleOnSubmit = (ref) => {
    ref.current.focus();
    if (ref === fromDateBox) {
      setShowDate(true);
    }
  };

  const submitForm = (values) => {
    let source, destination;
    
    if (values.sourceId && values.sourceId.includes('cityName=')) {
      source = queryString.parse(values.sourceId);
    } else {
      const sourceCity = findCityInCache(values.sourceId);
      source = {
        cityName: values.sourceId,
        cityId: sourceCity ? sourceCity.cityId : values.sourceId
      };
    }
    
    if (values.destinationId && values.destinationId.includes('cityName=')) {
      destination = queryString.parse(values.destinationId);
    } else {
      const destCity = findCityInCache(values.destinationId);
      destination = {
        cityName: values.destinationId,
        cityId: destCity ? destCity.cityId : values.destinationId
      };
    }
    
    let formData = {
      sourceId: source.cityId,
      destinationId: destination.cityId,
      journeyDate: moment(values.journeyDate).format(),
      sourceName: source.cityName,
      destinationName: destination.cityName,
      tags: values.filterOptions ? values.filterOptions.toString() : "",
      Api: values.apisOptions ? values.apisOptions.toString() : ""
    };
    const query = queryString.stringify(formData);
    history.push("/admin/busresults?" + query);
    
    if (modifySearch) {
      busesSearchAPI();
    }
  };
  
  useEffect(() => {
    if (modifySearch) {
      let param = queryString.parse(document.location.search);
      form.setFieldsValue({
        sourceId: `cityName=${param.sourceName}&cityId=${param.sourceId}`,
        destinationId: `cityName=${param.destinationName}&cityId=${param.destinationId}`,
        journeyDate: moment(param.journeyDate),
        filterOptions: param.tags.split(","),
        apisOptions: param.Api.split(",")
      });
      setCarrier(param.tags.split(","));
      setApisName(param.Api.split(","))
    }
  }, []);

  const handleFilterName = (e, name) => {
    let array = [...carrier];
    if (e.target.checked) {
      array.push(name);
    } else {
      let index = array.indexOf(name);
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setCarrier(array);
  };

  const handelApisName = (e, name) => {
    let array = [...apisName];
    if (e.target.checked) {
      array.push(name);
    } else {
      let index = array.indexOf(name);
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setApisName(array);
  }

  return (
    <div>
      <div className="hotels_search_box buses-panel-align-bd">
        <div className="hotels-wrapper">
          {/* Voice Search Feedback */}
          {showVoiceFeedback && (voiceDetectedTags.length > 0 || voiceDetectedApis.length > 0) && (
            <Alert
              message="🎤 Voice Search Detected"
              description={
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                  {voiceDetectedTags.length > 0 && (
                    <div>
                      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Applied Filters:</div>
                      <Space wrap>
                        {voiceDetectedTags.map(tag => (
                          <Tag 
                            key={tag} 
                            color="blue"
                            icon={<CheckCircleOutlined />}
                          >
                            {getFilterDisplayName(tag)}
                          </Tag>
                        ))}
                      </Space>
                    </div>
                  )}
                  {voiceDetectedApis.length > 0 && user?.role?.toUpperCase() === "ADMIN" && (
                    <div>
                      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Applied APIs:</div>
                      <Space wrap>
                        {voiceDetectedApis.map(api => (
                          <Tag 
                            key={api} 
                            color="green"
                            icon={<CheckCircleOutlined />}
                          >
                            {getApiDisplayName(api)}
                          </Tag>
                        ))}
                      </Space>
                    </div>
                  )}
                </Space>
              }
              type="success"
              showIcon
              closable
              onClose={() => setShowVoiceFeedback(false)}
              style={{ marginBottom: '16px' }}
            />
          )}

          <Form
            form={form}
            className="hotel-search-form  bus-panel-bg"
            name="busForm"
            validateMessages={validateMessages}
            onFinish={submitForm}
            layout="vertical"
            initialValues={{ filterOptions: [], apisOptions: [] }}
          >
            <Row className="bus-search-form" gutter={16}>
              <Col md={6} xs={24} className="from-to-inputs bus-cols-info">
                <BusesAutoSelect
                  formItemProps={{
                    label: "Source",
                    name: "sourceId",
                    rules: [{ required: true }],
                  }}
                  selectProps={{
                    size: "medium",
                    placeholder: "Enter Source Name",
                   }}
                  api={"cdn/citiesMatched/"}
                  refName={city}
                  focusRef={tocityBox}
                  handleOnSubmit={handleOnSubmit}
                  modifySearch={modifySearch ? modifySearch : false}
                />
              </Col>
              <Col md={6} xs={24} className="from-to-inputs bus-cols-info">
                <BusesAutoSelect
                  formItemProps={{
                    label: "Destination",
                    name: "destinationId",
                    rules: [{ required: true }],
                  }}
                  selectProps={{
                    size: "medium",
                    placeholder: "Enter Destination Name",
                   }}
                  api={"cdn/citiesMatched/"}
                  refName={tocityBox}
                  focusRef={fromDateBox}
                  handleOnSubmit={handleOnSubmit}
                  modifySearch={modifySearch ? modifySearch : false}
                />
              </Col>
              <Col md={4} xs={24} className="from-to-inputs bus-cols-info">
                <Form.Item name="journeyDate" label="Journey Date" rules={[{ required: true }]}>
                  <DatePicker
                    allowClear={false}
                    size="medium"
                    className="search-inputs from-return-date"
                    placeholder="Journey Date"
                    ref={fromDateBox}
                    format={dateFormat}
                    open={showDate}
                    disabledDate={disabledOriginDate}
                    onOpenChange={() => {
                      setShowDate((prev) => !prev);
                    }}
                  />
                </Form.Item>
              </Col>

              <Col md={4} xs={24} className="bus-cols-info">
                <Form.Item className="mr-none">
                  <Button
                    size="large"
                    className="primary-btn btn_new train-search-btn bus-btn-pri"
                    ref={searchBtn}
                    htmlType="submit"
                  >
                    <SearchOutlined /> Search
                  </Button>
                </Form.Item>
              </Col>

              {/* Voice Recognition Button */}
              <Col md={2} xs={24} className="bus-cols-info">
                <Form.Item label=" ">
                  <Tooltip title={isListening ? "Stop listening" : `Voice search ${isCitiesLoading ? '(Loading cities...)' : '(Ready)'}`}>
                    <Button
                      size="large"
                      className={`voice-btn ${isListening ? 'listening' : ''} ${isCitiesLoading ? 'loading' : ''}`}
                      onClick={toggleListening}
                      disabled={isCitiesLoading}
                      style={{
                        height: '40px',
                        width: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: isListening ? '#ff4d4f' : (isCitiesLoading ? '#d9d9d9' : '#1890ff'),
                        border: 'none',
                        animation: isListening ? 'pulse 1.5s infinite' : 'none'
                      }}
                    >
                      {isListening ? 
                        <AudioMutedOutlined style={{ color: 'white', fontSize: '18px' }} /> : 
                        <AudioOutlined style={{ color: 'white', fontSize: '18px' }} />
                      }
                    </Button>
                  </Tooltip>
                </Form.Item>
              </Col>
            </Row>

            <Collapse className="collapse-margin">
              <Panel header="More Options" key="1">
                <Form.Item name="filterOptions" label="" className="check-margin">
                  <CheckboxGroup className="css-for-row">
                    <Row>
                      {filterOptions.map((item) => (
                        <Col key={item.value} sm={8} xs={24} className="rows-of-more">
                          <Checkbox
                            className="checking"
                            value={item.value}
                            onChange={(e) => handleFilterName(e, item.name)}
                            checked={voiceDetectedTags.includes(item.value)}
                            style={{
                              fontWeight: voiceDetectedTags.includes(item.value) ? 'bold' : 'normal',
                              color: voiceDetectedTags.includes(item.value) ? '#1890ff' : 'inherit'
                            }}
                          >
                            {item.name}
                            {voiceDetectedTags.includes(item.value) && (
                              <span style={{ marginLeft: '4px', color: '#52c41a' }}>
                                ✓
                              </span>
                            )}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </CheckboxGroup>
                </Form.Item>

                {user?.role?.toUpperCase() == "ADMIN" && (
                  <div className="label-panel-data">
                    <Form.Item name="apisOptions" label=" " className="check-margin">
                      <CheckboxGroup className="check-box-check">
                        <Row>
                          {apisOptions.map((item) => (
                            <Col key={item.value} className="rows-of-more2">
                              <Checkbox
                                value={item.value}
                                onChange={(e) => handelApisName(e, item.name)}
                                checked={voiceDetectedApis.includes(item.value)}
                                style={{
                                  fontWeight: voiceDetectedApis.includes(item.value) ? 'bold' : 'normal',
                                  color: voiceDetectedApis.includes(item.value) ? '#1890ff' : 'inherit'
                                }}
                              >
                                {item.name}
                                {voiceDetectedApis.includes(item.value) && (
                                  <span style={{ marginLeft: '4px', color: '#52c41a' }}>
                                    ✓
                                  </span>
                                )}
                              </Checkbox>
                            </Col>
                          ))}
                        </Row>
                      </CheckboxGroup>
                    </Form.Item>
                  </div>
                )}
              </Panel>
            </Collapse>
          </Form>
        </div>
      </div>

      {/* Add CSS animation for pulse effect */}
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.7);
          }
          70% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(255, 77, 79, 0);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
          }
        }
      `}</style>
    </div>
  );
};

export default Buses;